<template>
  <div class="feedback-page">
    <header class="feedback-header">
      <button
        class="back-btn"
        type="button"
        :aria-label="$t('utils.cancel')"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('user.complaint') }}</h1>
    </header>

    <main class="feedback-body">
      <section class="feedback-card">
        <textarea
          v-model="message"
          class="feedback-textarea"
          :maxlength="maxLength"
          :placeholder="$t('user.feedbackPlaceholder')"
        />
        <div class="counter">
          {{ message.length }}/{{ maxLength }}
        </div>
        <div class="divider" />
        <button
          class="submit-btn"
          type="button"
        >
          {{ $t('utils.submit') }}
        </button>
      </section>
    </main>

    <!-- <div
      class="kefu"
      @click.stop="$router.push('/kefu')"
    >
      <div class="kefu_img">
        <van-icon name="service-o" />
      </div>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: 'Feedback',
  data() {
    return {
      message: '',
      maxLength: 300,
    };
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('', true);
    }
  },
};
</script>

<style lang="less" scoped>
.feedback-page {
  min-height: 100vh;
  padding-bottom: 72px;
  background: #f5f3f4;
  color: #07152b;
}

.feedback-header {
  position: sticky;
  top: 0;
  z-index: 8;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f6fb;
}

.feedback-header h1 {
  margin: 0;
  color: #07152b;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}

.back-btn {
  position: absolute;
  left: 16px;
  top: 50%;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  transform: translateY(-50%);
  background: transparent;
  color: #07152b;
  font-size: 14px;
}

.feedback-body {
  padding: 16px 14px 0;
}

.feedback-card {
  height: 675px;
  padding: 28px 34px 0;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
}

.feedback-textarea {
  width: 100%;
  height: 316px;
  display: block;
  padding: 0;
  border: 0;
  outline: none;
  resize: none;
  background: transparent;
  color: #172033;
  font-size: 14px;
  line-height: 22px;
  box-sizing: border-box;
}

.feedback-textarea::placeholder {
  color: #bfc5cc;
}

.counter {
  color: #3f4858;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
}

.divider {
  height: 1px;
  margin: 12px 0 38px;
  background: #f4f4f4;
}

.submit-btn {
  width: 356px;
  max-width: 100%;
  height: 50px;
  display: block;
  margin: 0 auto;
  padding: 0;
  border: 0;
  border-radius: 30px;
  background: #fb0d0d;
  color: #fff;
  font-size: 14px;
  line-height: 50px;
  text-align: center;
}

.kefu {
  position: fixed;
  right: 15px;
  bottom: 88px;
  z-index: 80;
  width: 62px;
  height: 62px;
}

.kefu_img {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 4px solid #fff;
  border-radius: 50%;
  background: linear-gradient(180deg, #1b7dff 0%, #0d80ff 64%, #fb1426 65%, #fb1426 100%);
  box-shadow: 0 6px 14px rgba(30, 70, 130, 0.25);
  color: #fff;
  box-sizing: border-box;
}

.kefu_img .van-icon {
  font-size: 31px;
}
</style>
